import React from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineClose } from 'react-icons/md';
import { name } from '../../constants/images';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import './Navbar.css';
import { ABOUT_ROUTE, BOOKING_ROUTE, CONTACT_ROUTE, COPYRIGHT_POLICY_ROUTE, FAQS_ROUTE, HOME_ROUTE, LOGIN_ROUTE, PACKAGES_ROUTE, PRIVACY_POLICY_ROUTE, REGISTER_ROUTE, SERVICE_POLICY_ROUTE } from '../../../../../../routing/routing_constants';

export const Navbar = () => {
  const [toggleMenu, setToggleMenu] = React.useState(false);
  const [moreMenu, setToggleMoreMenu] = React.useState(null)


  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event, more_links) => {
    setAnchorEl(event.currentTarget);
    setToggleMoreMenu(more_links)
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const services_more_links = (
    <ul className="app__navbar-more-overlay_links">
      <li><a href={PACKAGES_ROUTE} onClick={() => setToggleMoreMenu(false)}>Transfers & transport</a></li>
      <li><a href={PACKAGES_ROUTE} onClick={() => setToggleMoreMenu(false)}>Tours & Safaris</a></li>
    <li><a href={PACKAGES_ROUTE} onClick={() => setToggleMoreMenu(false)}>Vacations & Planning</a></li>
    <li><a href={PACKAGES_ROUTE} onClick={() => setToggleMoreMenu(false)}>Tickets Booking</a></li>
    </ul>
  )

  const home_more_links = (
    <ul className="app__navbar-more-overlay_links">
    <li><a href={HOME_ROUTE} onClick={() => setToggleMoreMenu(false)}>Home</a></li>
    <li><a href={LOGIN_ROUTE} onClick={() => setToggleMoreMenu(false)}>Login</a></li>
   <li><a href={REGISTER_ROUTE} onClick={() => setToggleMoreMenu(false)}>Register</a></li>
  </ul>
  )

  const about_more_links = (
    <ul className="app__navbar-more-overlay_links">
    <li><a href={ABOUT_ROUTE} onClick={() => setToggleMoreMenu(false)}>About DGA</a></li>
    <li><a href={PRIVACY_POLICY_ROUTE} onClick={() => setToggleMoreMenu(false)}>Privacy Policy</a></li>
    <li><a href={COPYRIGHT_POLICY_ROUTE} onClick={() => setToggleMoreMenu(false)}>Copyright Policy</a></li>
    <li><a href={SERVICE_POLICY_ROUTE} onClick={() => setToggleMoreMenu(false)}>Service Policy</a></li>
  </ul>
  )
  const contact_more_links = (
    <ul className="app__navbar-more-overlay_links">
    <li><a href={CONTACT_ROUTE} onClick={() => setToggleMoreMenu(false)}>Online contact form</a></li>
    <li><a href={CONTACT_ROUTE} onClick={() => setToggleMoreMenu(false)}>Send direct message(email/phone)</a></li>
  </ul>
  )
  const faqs_more_links = (
    <ul className="app__navbar-more-overlay_links">
    <li><a href={FAQS_ROUTE} onClick={() => setToggleMoreMenu(false)}>How to book a package</a></li>
    <li><a href={FAQS_ROUTE} onClick={() => setToggleMoreMenu(false)}>Our service rates</a></li>
   <li><a href={FAQS_ROUTE} onClick={() => setToggleMoreMenu(false)}>Ask a question</a></li>
    <li><a href={FAQS_ROUTE} onClick={() => setToggleMoreMenu(false)}>All FAQs</a></li>
    {/* <li><a href={CONTACT_ROUTE} onClick={() => setToggleMoreMenu(false)}>Contact Us</a></li> */}
  </ul>
  )

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <a href='home'><img src={name} alt="app__logo" /></a>
      </div>
      <ul className="app__navbar-links">
        <li className="p__opensans"><p onClick={(e) => handleClick(e, home_more_links)}>Home</p></li>
        <li className="p__opensans"><p onClick={(e) => handleClick(e, about_more_links)}>About</p></li>
        <li className="p__opensans"><p onClick={(e) => handleClick(e, services_more_links)}>Services</p></li>
        <li className="p__opensans"><p onClick={(e) => handleClick(e, faqs_more_links)}>FAQs</p></li>
        <li className="p__opensans"><p onClick={(e) => handleClick(e, contact_more_links)}>Contact</p></li>
      </ul>
      <div className="app__navbar-login">
        <a href={LOGIN_ROUTE} className="p__opensans">Login</a>
        <div />
        <a href={REGISTER_ROUTE} className="p__opensans">SignUp</a>
      </div>
        <div className='app__navbar-more_overlay'>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            {moreMenu}
          </Menu>
      </div>

      <div className="app__navbar-smallscreen">
        <GiHamburgerMenu color="#000000" fontSize={27} onClick={() => setToggleMenu(true)} />
        {toggleMenu && (
          <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
            <MdOutlineClose fontSize={27} className="overlay__close" onClick={() => setToggleMenu(false)} />
            <ul className="app__navbar-smallscreen_links">
              <li className="p__opensans"><p onClick={(e) => handleClick(e, home_more_links)}>Home</p></li>
              <li className="p__opensans"><p onClick={(e) => handleClick(e, about_more_links)}>About</p></li>
              <li className="p__opensans"><p onClick={(e) => handleClick(e, services_more_links)}>Services</p></li>
              <li className="p__opensans"><p onClick={(e) => handleClick(e, faqs_more_links)}>FAQs</p></li>
              <li className="p__opensans"><p onClick={(e) => handleClick(e, contact_more_links)}>Contact</p></li>
              <hr />
              <li className="p__opensans"><a href={LOGIN_ROUTE} className="p__opensans">Login</a></li>
              <li className="p__opensans"><a href={REGISTER_ROUTE} className="p__opensans">SignUp</a></li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

// export default Navbar;

